// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fxxljJ{list-style:none;margin:0;padding:12px 0;position:absolute;width:100%;left:0;top:0;visibility:hidden}.fxxljJ.I3Os26{visibility:visible}button.K2Rg1r{display:flex;gap:10px;align-items:center;height:36px;padding:0 24px;border:none;background:none;width:100%;text-align:left;color:white;cursor:pointer;transition:background .1s}button.K2Rg1r:hover{background:rgba(100,100,100,0.7)}.uqn3Xp{flex-grow:1;font-size:14px;font-weight:bold}.cUe7EV{font-size:14px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `fxxljJ`,
	"visible": `I3Os26`,
	"button": `K2Rg1r`,
	"title": `uqn3Xp`,
	"value": `cUe7EV`
};
export default ___CSS_LOADER_EXPORT___;
